export const earlySeasonFungicide = {
  products: [
    { id: 'headline', baseRate: 10.0, maxApplicationRate: 14.4, label: 'Headline AMP', company: 'BASF' },
    { id: 'priaxor', baseRate: 4.0, maxApplicationRate: 8, label: 'Priaxor', company: 'BASF' },
    { id: 'trivapro', baseRate: 13.7, maxApplicationRate: 13.7, label: 'Trivapro', company: 'SYNGENTA' },
    { id: 'delaro', baseRate: 8.0, maxApplicationRate: 12.0, label: 'Delaro Complete', company: 'BAYER' },
    { id: 'aproachPrima', baseRate: 3.4, maxApplicationRate: 6.8, label: 'Aproach Prima', company: 'DUPONT' },
    { id: 'other', baseRate: 3.4, maxApplicationRate: 6.8, label: 'Other', company: '' },
  ],
};
